RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.PptPanel = App.views.Panel.mixin({
        template: '#dashboardPPTWidgetTemplate',
        className: 'ppt-panel',

        onRender: function () {
            const me = this;

            me.showContent();
        }
    });
});
